export default __webpack_public_path__ + "static/media/Scott Dourque.e663a776.jpg";